import { currentOrganization } from '@fastlessjs/backoffice-layer/dist/hooks';

import { t } from '../../config/translations';
import { returnReasonOptions } from '../../utils/communSchemas';

export const navigateOrder = (record: { ndoc?: number; orderId?: string }) => {
  return `/${currentOrganization()?.organizationId.toLocaleLowerCase()}/orders/${
    record?.ndoc || record?.orderId
  }/view`;
};

export const orderListSchema: any = {
  title: 'Orders',
  type: 'object',
  properties: {
    ndoc: {
      type: 'integer',
      get title() {
        return t('schema.orderNumber');
      },
      decorators: { search: true, searchable: true, copy: true, navigate: navigateOrder },
    },
    refc: {
      type: 'string',
      get title() {
        return t('schema.clientReference');
      },
      decorators: { search: true, searchable: true, copy: true },
    },
    mdtt: {
      type: 'string',
      get title() {
        return t('schema.totalAmount');
      },
      decorators: { search: true, numeral: { currencySymbol: '€' }, searchable: true },
    },
    dtac: {
      type: 'integer',
      get title() {
        return t('schema.receptionDate');
      },
      decorators: {
        search: true,
        searchable: true,
        dateFormat: {
          stringFormat: 'dd/MM/yyyy',
          isNumber: { actualFormat: 'yyyyMMdd' },
        },
      },
    },
    etat: {
      type: 'string',
      get title() {
        return t('schema.status');
      },
      uniforms: {
        checkboxes: true,
        options: [
          { label: 'ANNULEE', value: '05ANNULEE', color: 'blue' },
          { label: 'ERREUR', value: '99ERREUR', color: 'blue' },
          { label: 'ENSTATS', value: '60ENSTATS', color: 'blue' },
          { label: 'FACTUREE', value: '50FACTUREE', color: 'blue' },
          { label: 'EXPEDIEE', value: '40EXPEDIEE', color: 'blue' },
          { label: 'PREPA', value: '20PREPA', color: 'blue' },
          { label: 'RESERVEE', value: '10RESERVEE', color: 'blue' },
          { label: 'SAISIE', value: '00SAISIE', color: 'blue' },
        ],
      },
      decorators: {
        search: true,
        filterable: {
          options: [
            { label: 'ANNULEE', value: '05ANNULEE', color: 'blue' },
            { label: 'ERREUR', value: '99ERREUR', color: 'blue' },
            { label: 'ENSTATS', value: '60ENSTATS', color: 'blue' },
            { label: 'FACTUREE', value: '50FACTUREE', color: 'blue' },
            { label: 'EXPEDIEE', value: '40EXPEDIEE', color: 'blue' },
            { label: 'PREPA', value: '20PREPA', color: 'blue' },
            { label: 'RESERVEE', value: '10RESERVEE', color: 'blue' },
            { label: 'SAISIE', value: '00SAISIE', color: 'blue' },
          ],
        },
      },
    },
    type: {
      type: 'string',
      get title() {
        return t('schema.type');
      },
      decorators: { hide: ['details'] },
    },
    lignes: {
      type: 'array',
      get title() {
        return t('schema.lines');
      },
      decorators: { hide: ['details'] },
      items: {
        type: 'object',
        properties: {
          desi: {
            type: 'string',
            get title() {
              return t('schema.designation');
            },
            decorators: { search: true },
          },
          nart: {
            type: 'string',
            get title() {
              return t('schema.articleNumber');
            },
            decorators: { search: true },
          },
          qcde: {
            type: 'string',
            get title() {
              return t('schema.qtyOrdered');
            },
            decorators: { search: true },
          },
          qret: {
            type: 'string',
            get title() {
              return t('schema.qtyToReturn');
            },
            decorators: { search: true },
          },
          cact: {
            type: 'string',
            get title() {
              return t('schema.returnType');
            },
            uniforms: {
              checkboxes: true,
              options: [
                {
                  get label() {
                    return t('schema.credit');
                  },
                  value: 'ERM',
                },
                {
                  get label() {
                    return t('schema.exchange');
                  },
                  value: 'ECS',
                },
              ],
            },
            decorators: { search: true },
          },
          clit: {
            type: 'string',
            get title() {
              return t('schema.returnReason');
            },
            uniforms: {
              checkboxes: true,
              options: returnReasonOptions,
            },
            decorators: { search: true },
          },
          size: {
            type: 'string',
            get title() {
              return t('schema.requestedSize');
            },
            decorators: { search: true },
          },
          new_nart: {
            type: 'string',
            get title() {
              return t('schema.replacementArticle');
            },
          },
        },
      },
    },
  },
  required: [],
};
